"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const Script = require("next/script");
const client = require("@prismicio/client");
const resolveDefaultExport = require("./lib/resolveDefaultExport.cjs");
const PrismicPreviewClient = require("./PrismicPreviewClient.cjs");
const PrismicPreview = async (props) => {
  const { repositoryName, children, ...otherProps } = props;
  const { draftMode } = await import("next/headers");
  const toolbarSrc = client.getToolbarSrc(repositoryName);
  const isDraftMode = (await draftMode()).isEnabled;
  const ResolvedScript = resolveDefaultExport.resolveDefaultExport(Script);
  return jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [children, jsxRuntime.jsx(PrismicPreviewClient.PrismicPreviewClient, { repositoryName, isDraftMode, ...otherProps }), jsxRuntime.jsx(ResolvedScript, { src: toolbarSrc, strategy: "lazyOnload" })] });
};
exports.PrismicPreview = PrismicPreview;
//# sourceMappingURL=PrismicPreview.cjs.map
